import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import routes from './routes';


Vue.use(VueRouter);

const router = new VueRouter({
    routes,
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
});

router.beforeEach(async (to, from, next) => {
    store.dispatch('loading/setActive', true);
    // just logged in: localStorage has token, but state does not have auth user
    let token = Vue.ls.get('token');
    let logged = store.getters['auth/isLoggedIn'];
    if (token && !logged) {
        let {data: authUser} = await axios.post('me');
        await store.dispatch('auth/setAuthUser', authUser);
    }
    if (to.meta.requiresAuth) {
        if (logged || token) {
            try{
                let valid = await axios.post('valid-route', {ruta: to.name});
                if (valid.data) {
                    return next();
                } else {
                    return next({name: '404'});
                }
            }catch (e) {
                return next({name: 'login'});
            }

        } else {
            return next({name: 'login'});
        }

    }

    if (to.meta.requiresGuest) {
        if (logged || token)
            return next({name: 'home'});
        else
            return next();
    }
    store.dispatch('config/setLayout', to.meta.layout || 'sinmenu');
    next();
});

router.afterEach((to, from) => {
    store.dispatch('config/setLayout', to.meta.layout || 'sinmenu');
    store.dispatch('loading/setActive', false);
});

export default router;


// WEBPACK FOOTER //
// ./resources/assets/js/router/index.js